/* @flow */
// typecheck: ignore file
import React from 'react';
import BoxSelect from 'components/BoxSelect.jsx';
import BadgedBox from 'components/BadgedBox.jsx';
import BoxSelectItem from 'components/BoxSelectItem.jsx';
import Notice from 'components/Notice.jsx';
import Text from 'components/Text.jsx';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

import './styles/AdminLanding.scss';

type Props = {
  user?: {
    first_name: string,
    pending_organizations: {id: number, type: string}[],
    districts: {id: number}[],
    schools: {id: number}[],
  },
};

function AdminLanding(props: Props) {
  const title = props.user
    ? <span>Hello {props.user.first_name}, where do you want to go?</span>
    : <span>Hello _ _ _ _ , where do you want to go?</span>;

  const pending = props.user
    ? props.user.pending_organizations.length > 0
    : false;

  let type = '_ _ _';

  if (props.user) {
    if (props.user.pending_organizations.length > 0) {
      type = props.user.pending_organizations[0].type.toLowerCase();
    }

    if (props.user.schools.length > 0) {
      type = 'school';
    }

    if (props.user.districts.length > 0) {
      type = 'district';
    }
  }

  return (
    <div className="AdminLanding">
      <div className="AdminLanding-content">
        {pending &&
          <div className="AdminLanding-notice">
            <Notice glyph="bell-stroke" color="flame">
              We are currently verifying your account.
            </Notice>
          </div>
        }
        <BoxSelect key="one" title={title}>
          <BoxSelectItem
            eventElementName="AdminLanding-Core-Link"
            to="/classes"
            border
            size="large"
            icon={require('assets/images/admin/comments.svg')}>
            <Text element="div" size="xlarge" weight="semibold" color="brand">Remind</Text>
            <Text element="div" size="small" weight="semibold" color="brand">See what your teachers see</Text>
            <Text className="AdminLanding-info">
              Remind is the tool your teachers use to connect
              with their students and parents. You can use it
              to message your district schools, too.
            </Text>
          </BoxSelectItem>
          <BadgedBox text="New">
            <BoxSelectItem
              eventElementName="AdminLanding-Dashboard-Link"
              to="/admin"
              border
              size="large"
              icon={require('assets/images/admin/infographics.svg')}>
              <Text element="div" size="xlarge" weight="semibold" color="brand">Admin Console</Text>
              <Text element="div" size="small" weight="semibold" color="brand">Manage your {type}</Text>
              <Text className="AdminLanding-info">
                The Admin Console is used for managing all the
                people in your district and schools. Only verified
                administrators have access to this tool.
              </Text>
            </BoxSelectItem>
          </BadgedBox>
        </BoxSelect>
      </div>
    </div>
  );
}

const withUser = graphql(gql`
  query {
    user: me {
      id
      first_name
      districts: organizations(first: 1, type: "district", affiliation_status: [admin]) {
        id
      }
      schools: organizations(first: 1, type: "school", affiliation_status: [admin]) {
        id
      }
      pending_organizations: organizations(first: 1, affiliation_status: [pending_admin]) {
        id
        type
      }
    }
  }`, {
    props: ({ data }) => ({ user: data.user }),
  }
);

export { AdminLanding };
export default withUser(AdminLanding);



// WEBPACK FOOTER //
// ./src/admin/components/AdminLanding.jsx